import { useContext } from 'react';

import { PieChartLoadingContext } from '../context/PieChartLoadingContext.js';

export const usePieChartLoading = () => useContext(PieChartLoadingContext);
